"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsMenu = void 0;
const common_types_1 = require("../../common-types");
const react_1 = __importStar(require("react"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton/IconButton"));
const Menu_1 = __importDefault(require("@material-ui/core/Menu"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const DoneAll_1 = __importDefault(require("@material-ui/icons/DoneAll"));
const Visibility_1 = __importDefault(require("@material-ui/icons/Visibility"));
const VisibilityOff_1 = __importDefault(require("@material-ui/icons/VisibilityOff"));
const notification_context_1 = require("../../modules/notification/notification-context");
const infinite_list_1 = require("../infinite-list/infinite-list");
const tooltip_1 = require("../tooltip/tooltip");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const scrollable_source_hook_1 = require("../../utils/scrollable-source-hook");
const read_all_hook_1 = require("./actions/read-all-hook");
const notification_1 = require("./notification");
const notification_styles_1 = require("./notification-styles");
function NotificationsMenu({ open, setOpen, anchorRef, resetCount, }) {
    const classes = (0, notification_styles_1.useNotificationMenuStyles)();
    const [includeRead, setIncludeRead] = (0, react_1.useState)(false);
    const infiniteList = (0, react_1.useRef)(null);
    const { notificationUrl } = (0, react_1.useContext)(notification_context_1.NotificationContext);
    const source = (0, scrollable_source_hook_1.useScrollableSource)({
        url: `${notificationUrl}/received/list`,
        params: {
            filters: [
                { field: 'read', operation: common_types_1.ApiFilterOperation.EQ, value: false },
            ],
        },
    });
    const closeMenu = () => {
        setOpen(false);
    };
    const handleReset = (0, event_callback_hook_1.useEventCallback)(() => {
        source.reset();
        resetCount();
        source.loadMore();
    });
    const { handleReadAll } = (0, read_all_hook_1.useReadAll)({ refresh: handleReset });
    const handleShowAll = (0, event_callback_hook_1.useEventCallback)(() => {
        setIncludeRead((value) => !value);
        if (includeRead) {
            source.setParams({
                filters: [
                    { field: 'read', operation: common_types_1.ApiFilterOperation.EQ, value: false },
                ],
            });
        }
        else {
            source.setParams({
                filters: [],
            });
        }
        source.reset();
        source.loadMore();
    });
    (0, react_1.useEffect)(() => {
        if (open) {
            source.reset();
            source.loadMore();
        }
    }, [open]);
    return (react_1.default.createElement(Menu_1.default, { open: open, getContentAnchorEl: null, anchorEl: anchorRef.current, onClose: closeMenu, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }, MenuListProps: {
            disablePadding: true,
        }, PaperProps: {
            className: classes.menu,
        } },
        react_1.default.createElement("div", { style: { height: source.loading ? 500 : 'fit-content' } },
            react_1.default.createElement("div", { className: classes.header },
                react_1.default.createElement(Typography_1.default, { component: "div", variant: "body1" },
                    "Notifikace",
                    !source.loading && react_1.default.createElement(react_1.default.Fragment, null,
                        " (",
                        source.count,
                        ")")),
                react_1.default.createElement("div", { className: classes.icons },
                    react_1.default.createElement(tooltip_1.Tooltip, { title: includeRead ? 'Skrýt přečtené' : 'Zobrazit přečtené' },
                        react_1.default.createElement(IconButton_1.default, { className: classes.icon, size: "small", onClick: handleShowAll }, includeRead ? react_1.default.createElement(VisibilityOff_1.default, null) : react_1.default.createElement(Visibility_1.default, null))),
                    react_1.default.createElement(tooltip_1.Tooltip, { title: "Ozna\u010Dit v\u0161e za p\u0159e\u010Dten\u00E9" },
                        react_1.default.createElement(IconButton_1.default, { className: classes.icon, size: "small", onClick: handleReadAll },
                            react_1.default.createElement(DoneAll_1.default, null))))),
            source.loading && (react_1.default.createElement("div", { className: classes.loaderWrapper },
                react_1.default.createElement(CircularProgress_1.default, { disableShrink: true, className: classes.loader }))),
            open && (react_1.default.createElement(infinite_list_1.InfiniteList, { ref: infiniteList, source: source, maxListHeight: 450, labelMapper: (item) => (react_1.default.createElement(notification_1.Notification, { item: item, refreshNotifications: handleReset })) })),
            source.count === 0 && !source.loading && (react_1.default.createElement(Typography_1.default, { variant: "body1", style: { padding: 10 } }, "V\u0161e p\u0159e\u010Dteno")))));
}
exports.NotificationsMenu = NotificationsMenu;
//# sourceMappingURL=notification-menu.js.map